/**
 * Two-letter initials from a display name — the single source of truth for every
 * avatar/owner chip in the domain (CT-5093):
 *   - two or more words → first letter of the first two words ("Marcus Holloway" → "MH")
 *   - a single word     → its first two letters ("Ada" → "AD")
 *   - blank/absent      → "" (or the fallback, below)
 * The result is always uppercased.
 *
 * When the name yields nothing, falls back to the first two chars of `fallback`
 * (e.g. a user uuid), so an id-only owner still shows something.
 *
 * @param {string|null|undefined} name
 * @param {string|null|undefined} [fallback]
 * @returns {string}
 */
export function initialsFromName(name, fallback = '') {
  const words = String(name ?? '')
    .split(/\s+/)
    .filter(Boolean);

  let result = '';
  if (words.length >= 2) {
    result = `${words[0][0]}${words[1][0]}`;
  } else if (words.length === 1) {
    result = words[0].slice(0, 2);
  }
  result = result.toUpperCase();
  if (result) return result;

  return String(fallback ?? '')
    .slice(0, 2)
    .toUpperCase();
}
